$(document).ready(function(){

  
  $(document).find('.category-box-item .tmenu_indicator').remove();
  $('.category-box-item .tmenu_item_link').hover(function(){
    $('.tmenu-watermark').remove();
  });
  setTimeout(function(){
    $(document).find('.category-box-item .tmenu_indicator').remove();
  }, 500);
  
  $('.header-category ul li a').click(function(e){
    e.preventDefault();
    $('.header-category ul li a').removeClass('active');
    $(this).addClass('active');
  });
  
  $('.search-input a').click(function(e){
    e.preventDefault();
    var input = $(this).siblings('input[type="search"]');
    input.toggle(); // Input alanının görünürlüğünü değiştir
    if (input.is(':visible')) {
        input.focus(); // Input alanına odaklan
    }
  });
  
  
  var swiper = new Swiper('.swiper-headline', {
    slidesPerView: 1, // Yalnızca bir slide göster
    spaceBetween: 30,
    loop: true, // Sonsuz döngü
     autoplay: {
        delay: 5000, // Otomatik oynatma için bekleme süresi (ms)
        disableOnInteraction: false, // Kullanıcı etkileşimiyle durmayı devre dışı bırak
    }, 
  });





var swiper = new Swiper('.swiper-product', {
  slidesPerView: "auto",
  spaceBetween: 0,
  loop: false,
  autoplay: {
      delay: 5000, 
  },
  pagination: {
      el: '.swiper-pagination',
      clickable: true,
  },
});





var swiper = new Swiper('.swiper-comments', {
  slidesPerView: 1,
  spaceBetween: 30,
  pagination: {
      el: '.swiper-pagination',
      clickable: true,
  },
});

});

 
  


  $(document).ready(function(){
    $('.accordion.active .accordion-content').slideDown();

    $('.accordion-header').click(function(){
        $(this).next('.accordion-content').slideToggle();
    });

    $('.show-more').click(function(){
        $(this).prev('.accordion-content').find('li:hidden').slice(0, 5).slideDown();
        if ($(this).prev('.accordion-content').find('li:hidden').length == 0) {
            $(this).hide();
        }
    });
});

$(document).ready(function() {
  $(".more-details-box").click(function() {
      $(".more-details-content").slideToggle();
      $(".more-details-icon").toggleClass("rotate");
  });
});



$(document).ready(function(){
  $(".reviews-filter-left, .reviews-filter-right").click(function(){
      $(this).find(".filter-dropdown-content").toggle();
  });
});


$(document).ready(function(){
  $(".like-button").click(function(){
      var likeCount = parseInt($(this).find(".like-count").text());
      $(this).find(".like-count").text(likeCount + 1);
  });
});


$(document).ready(function(){
  // Renk filtresi değiştiğinde tetiklenen fonksiyon
  $("input[name='color']").change(function(){
      // Seçilen renk değerini al
      var selectedColor = $(this).val();
      // Burada seçilen renge göre ürünleri filtreleme işlemlerini gerçekleştir
      // Örneğin, seçilen rengin ürünlerini listeleme gibi bir işlem yapılabilir.
      console.log("Seçilen Renk: " + selectedColor);
  });
});


$(document).ready(function(){
  $('.footer-box-item a').click(function(event){
      // Tıklanan menü öğesinin altındaki ul etiketini bul
      var menu = $(this).siblings('ul');
      // Menünün görünürlüğünü kontrol et
      if(menu.is(':visible')){
          // Eğer görünürse, gizle
          menu.slideUp();
      } else {
          // Eğer gizliyse, göster ve diğer menüleri gizle
          $('.footer-box-item ul').slideUp();
          menu.slideDown();
      }
      event.preventDefault(); // Tıklama olayının varsayılan davranışını durdur
  });
});




$(document).ready(function () {
  $('#hamburger-icon').click(function () {
      $('.mobile-menu').toggleClass('active');
  });
});


$(document).ready(function () {
  $('.accordion-toggle').click(function (e) {
      e.preventDefault();
      var accordionContent = $(this).next('.accordion-content');
      accordionContent.slideToggle(200);
      $('.accordion-content').not(accordionContent).slideUp(200);
  });
});